<template>
  <div class="outwork-time">
    <div class="title">
      <span class="title__h3">{{
        this.$lange == "en" ? "Working hours tracking" : "工程师出差时长"
      }}</span>
      <span class="title__tip"
        >({{ $lange == "en" ? "Update at" : "更新于" }}：{{ updateTime }})</span
      >
    </div>
    <div class="content">
      <div class="search">
        <el-date-picker
          class="spacing"
          v-model="timeForm.year"
          type="year"
          size="mini"
          value-format="yyyy"
          style="width: 120px"
        >
        </el-date-picker>
        <el-select
          class="spacing"
          v-model="timeForm.code"
          size="mini"
          clearable
          multiple
          collapse-tags
        >
          <el-option
            v-for="code in codes"
            :value="code.code"
            :label="code.title"
            :key="code.id"
          ></el-option>
        </el-select>
        <el-button class="spacing" size="mini" @click="searchTracking">
          {{ this.$lange == "en" ? "view" : "查看" }}
        </el-button>
      </div>
      <div class="time">
        <div class="time_content">
          <div class="table" style="width: 400px">
            <el-table height="402px" :data="tableData" size="mini" border>
              <el-table-column
                prop="userName"
                :label="$lange == 'en' ? 'Engineer' : '工程师'"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop="travelHours"
                :label="$lange == 'en' ? 'Travel hours' : '出差时长'"
                :width="$lange == 'en' ? '140px' : '80px'"
              ></el-table-column>
            </el-table>
          </div>
          <div class="chart" style="width: calc(100% - 400px)">
            <e-charts
              style="width: 100%"
              :options="timeOptions"
              auto-resize
            ></e-charts>
          </div>
        </div>
      </div>
      <div class="time_ratio">
        <div class="title" style="padding: 10px 12px">
          <span class="title__h3">{{
            $lange == "en" ? "Working hours by project" : "工程师出差占比"
          }}</span>
          <span class="title__tip"
            >({{ $lange == "en" ? "Update at" : "更新于" }}：{{
              updateTime1
            }})</span
          >
        </div>
        <div style="padding: 8px 0">
          <div class="search">
            <el-date-picker
              class="spacing"
              v-model="ratioForm.year"
              type="year"
              size="mini"
              value-format="yyyy"
              style="width: 120px"
            >
            </el-date-picker>
            <el-select
              class="spacing"
              v-model="ratioForm.code"
              size="mini"
              clearable
              multiple
              collapse-tags
            >
              <el-option
                v-for="code in codes"
                :value="code.code"
                :label="saveName(code)"
                :key="code.id"
              ></el-option>
            </el-select>
            <el-button class="spacing" size="mini" @click="searchTracking1">
              {{ this.$lange == "en" ? "view" : "查看" }}
            </el-button>
          </div>
          <div class="time_content">
            <div class="table">
              <el-table
                height="402px"
                header-cell-class-name="header-cell-style"
                :data="tableData1"
                size="mini"
                border
              >
                <el-table-column
                  prop="userName"
                  :label="$lange == 'en' ? 'Engineer' : '工程师'"
                  show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                  prop="travelHours"
                  :label="$lange == 'en' ? 'Travel hours' : '出差时长'"
                ></el-table-column>
                <el-table-column
                  min-width="109px"
                  prop="yearWorkHours"
                  :label="$lange == 'en' ? 'Working hours' : '应工作小时数'"
                ></el-table-column>
                <el-table-column
                  prop="travelRatio"
                  :label="$lange == 'en' ? 'Ratio' : '出差占比'"
                  :formatter="formatterRatio"
                ></el-table-column>
              </el-table>
            </div>
            <div class="chart">
              <e-charts
                style="width: 100%"
                :options="ratioOptions"
                auto-resize
              ></e-charts>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

import theme from "../graph/theme";
import ECharts from "../components/Charts.vue";
import "echarts/lib/chart/bar";
import "echarts/lib/component/legend";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/grid";
import "echarts/lib/component/dataZoom";
import "echarts/lib/component/markLine";

function formatterNoZero(params) {
  try {
    const value = Number(params.value);
    if (value !== 0) return value;
    else return "";
  } catch (e) {
    return "";
  }
}

export default {
  name: "EngineerOutworkTime",
  components: { ECharts },
  props: {
    codes: Array,
  },
  data() {
    const toYear = moment().format("YYYY");
    const defaultCode = this.codes.slice(0, 1).map((i) => i.code);

    return {
      timeForm: {
        year: toYear,
        code: defaultCode,
      },
      ratioForm: {
        year: toYear,
        code: defaultCode,
      },
      tableData: [],
      tableDataSort: [],
      tableData1: [],
      updateTime: "",
      updateTime1: "",
    };
  },
  created() {
    // this.fetchCountEmployeeWorkHour(this.timeForm);
    this.searchTracking();
    this.searchTracking1();
  },
  computed: {
    timeOptions() {
      // const sortTableData = this.sortDatas(this.tableData, "travelHours");
      const xAxisData = this.tableDataSort.map((i) => i["userName"]);
      const seriesData = this.tableDataSort.map((item) => ({
        name: item["userName"],
        value: item["travelHours"],
      }));
      const max = this.tableDataSort.reduce((pre, cur) => {
        pre = Math.max(cur["travelHours"], pre);
        return pre;
      }, 5);
      return {
        ...theme,
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        grid: {
          left: 32,
          top: 16,
          bottom: 16,
          right: 46,
          containLabel: true,
          show: true,
        },
        yAxis: {
          type: "category",
          data: xAxisData,
          inverse: true,
        },
        xAxis: {
          type: "value",
          max,
        },
        dataZoom: [
          {
            show: true,
            type: "slider",
            yAxisIndex: [0],
            startValue: 0,
            endValue: 7,
            width: "14px",
            backgroundColor: "#FAFAFA",
            fillerColor: "#ddd",
            zoomLock: true,
            borderColor: "transparent",
            handleStyle: {
              borderWidth: 0,
              opacity: 0,
            },
            showDataShadow: false, //是否显示数据阴影 默认auto
            showDetail: false, //即拖拽时候是否显示详细数值信息 默认true
          },
          {
            type: "inside",
            yAxisIndex: [0],
            zoomOnMouseWheel: false,
            moveOnMouseWheel: true,
          },
        ],
        series: [
          {
            name: "工程师出差时长",
            type: "bar",
            data: seriesData,
            label: {
              show: true,
              formatter: formatterNoZero,
            },
          },
        ],
      };
    },
    ratioOptions() {
      const xAxisData = this.tableData1.map((i) => i["userName"]);
      const seriesData = this.tableData1.map((item) => {
        return {
          name: item["userName"],
          value: item["travelRatio"],
        };
      });
      return {
        ...theme,
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
          formatter: "{b}: {c}%",
        },
        grid: {
          left: 32,
          right: 46,
          top: 16,
          bottom: 16,
          containLabel: true,
          show: true,
        },
        yAxis: {
          type: "category",
          data: xAxisData,
          inverse: true,
          // axisLabel: {
          //   show: true,
          //   interval: 0
          // }
        },
        dataZoom: [
          {
            show: true,
            type: "slider",
            yAxisIndex: [0],
            startValue: 0,
            endValue: 7,
            width: "14px",
            backgroundColor: "#FAFAFA",
            fillerColor: "#ddd",
            zoomLock: true,
            borderColor: "transparent",
            handleStyle: {
              borderWidth: 0,
              opacity: 0,
            },
            showDataShadow: false, //是否显示数据阴影 默认auto
            showDetail: false, //即拖拽时候是否显示详细数值信息 默认true
          },
          {
            type: "inside",
            yAxisIndex: [0],
            zoomOnMouseWheel: false,
            moveOnMouseWheel: true,
          },
        ],
        xAxis: {
          type: "value",
          max: 100,
          axisLabel: {
            formatter: "{value}%",
          },
        },
        series: [
          {
            name: "工程师出差占比",
            type: "bar",
            data: seriesData,
            label: {
              show: true,
              position: "right",
              formatter: (params) =>
                formatterNoZero(params) ? `${params.value}%` : "",
            },
            // markLine: {
            //   data: [{ type: "average", name: "平均值" }],
            //   label: {
            //     formatter: (params) =>
            //       formatterNoZero(params) ? `${params.value}%` : "",
            //   },
            // },
          },
        ],
      };
    },
  },
  methods: {
    sortDatas(datas, field) {
      const data = datas.sort((a, b) => b[field] - a[field]);
      return data;
    },
    saveName(data) {
      if (this.$lange == "en") {
        if (data.extraData && data.extraData.en) {
          return data.extraData.en;
        }
        return data.title;
      } else {
        return data.title;
      }
    },
    searchTracking() {
      this.fetchCountEmployeeWorkHour(this.timeForm);
    },
    searchTracking1() {
      this.fetchCountEmployeeWorkHour1(this.ratioForm);
    },
    formatterRatio(row, column, cellValue) {
      return cellValue + "%";
    },
    async fetchCountEmployeeWorkHour(payload) {
      const res = await this.ccRequest.do(
        "admin/fsb/employee/report/countEmployeeWorkHour",
        payload,
        "POSTJSON"
      );
      this.tableDataSort = Object.freeze(this.sortDatas(res, "travelHours"));
      this.tableData = Object.freeze(res);
      console.log("sort result:", this.tableDataSort);
      if (res.length > 0) {
        this.updateTime = moment(res[0].countTime).format("YYYY-MM-DD H[时]");
      }
      console.log(res);
    },
    async fetchCountEmployeeWorkHour1(payload) {
      const res = await this.ccRequest.do(
        "admin/fsb/employee/report/countEmployeeWorkHour",
        payload,
        "POSTJSON"
      );
      this.tableData1 = Object.freeze(this.sortDatas(res, "travelRatio"));
      if (res.length > 0) {
        this.updateTime1 = moment(res[0].countTime).format("YYYY-MM-DD H[时]");
      }
      console.log(res);
    },
  },
};
</script>

<style lang="scss" scoped>
.spacing {
  &:not(:first-child) {
    margin-left: 8px;
  }
}
.title {
  border-bottom: 1px solid #e4e4e4;
  padding: 10px 20px;
}
.title__h3 {
  font-size: 18px;
  font-weight: bold;
  display: inline-block;
  margin-right: 8px;
}
.title__tip {
  color: #ccc;
}

.time {
  margin-top: 16px;
}
.time_ratio {
  margin-top: 16px;
}

.time_content {
  padding-top: 8px;
  display: flex;
  width: 100%;
}

.table {
  width: 400px;
}
.content {
  padding: 8px;
}

.chart {
  width: calc(100% - 400px);
  border: 1px solid #aaa7a788;
  margin-left: 8px;
}

.el-table {
  border: 1px solid #aaa7a788;
  font-size: 14px;
}
.el-table ::v-deep th.el-table__cell.is-leaf,
.el-table ::v-deep td.el-table__cell {
  border-bottom: 1px solid #aaa7a788;
  border-right: 1px solid #aaa7a788;
}
</style>

<style>
.header-cell-style .cell {
  word-break: break-word;
}
</style>
